import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const moments = [{
  title: 'Scientific Sessions',
  desc: 'Breakthrough presentations',
  video: 'https://cdn.magicpatterns.com/uploads/mNUFnTYqaYhezKUw6apcfK/Cinematic shots when Bored at the Airport_.mp4'
}, {
  title: 'Booth Energy',
  desc: 'Real conversations',
  video: 'https://cdn.magicpatterns.com/uploads/fQFTKhbTs1W58wgx5hcKuv/stand.mp4'
}, {
  title: 'Behind the Scenes',
  desc: 'Team moments',
  video: 'https://cdn.magicpatterns.com/uploads/vNhaE8sRKqw4ChzivnuwFr/coffee.mp4'
}];
export const PostScreen3Highlights = ({
  onNext
}: Props) => {
  const [selected, setSelected] = useState(0);
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-68">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-slate-950 to-slate-950" data-id="element-69" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-70">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-green-500 font-semibold mb-4" data-id="element-71">
          02 — Highlights Reel
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-2xl font-bold text-white leading-tight mb-6" data-id="element-72">
          The moments that mattered
        </motion.h2>

        {/* Video player */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="relative bg-black rounded-3xl overflow-hidden mb-4 h-64" data-id="element-73">
          <video key={selected} src={moments[selected].video} autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-74" />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4" data-id="element-75">
            <h3 className="text-white font-semibold text-lg mb-1" data-id="element-76">
              {moments[selected].title}
            </h3>
            <p className="text-slate-300 text-sm" data-id="element-77">{moments[selected].desc}</p>
          </div>
        </motion.div>

        {/* Moment selector */}
        <div className="flex space-x-2 mb-6" data-id="element-78">
          {moments.map((moment, i) => <button key={i} onClick={() => setSelected(i)} className={`flex-1 p-3 rounded-xl border transition-all ${selected === i ? 'bg-green-600/20 border-green-500 text-white' : 'bg-slate-900/50 border-slate-800 text-slate-400 hover:border-slate-600'}`} data-id="element-79">
              <Play className="w-4 h-4 mx-auto mb-1" data-id="element-80" />
              <span className="text-xs font-medium block" data-id="element-81">{moment.title}</span>
            </button>)}
        </div>

        <div className="mt-auto" data-id="element-82">
          <button onClick={onNext} className="w-full bg-green-600 hover:bg-green-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-83">
            <span data-id="element-84">Continue</span>
            <ArrowRight className="w-5 h-5" data-id="element-85" />
          </button>
        </div>
      </div>
    </div>;
};